module.exports = __webpack_public_path__ + "static/media/apartment4.f3d37c17.jpg";